"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { MOT_COOKIE_PREFERENCES_CHANGED } from "@/components/CookieConsent";
import { captureCurrentMarketingClickIds } from "@/lib/marketing-attribution";

export function MarketingAttributionCapture() {
  const pathname = usePathname();

  useEffect(() => {
    const capture = () => captureCurrentMarketingClickIds();
    capture();
    window.addEventListener(MOT_COOKIE_PREFERENCES_CHANGED, capture);
    return () => window.removeEventListener(MOT_COOKIE_PREFERENCES_CHANGED, capture);
  }, [pathname]);

  return null;
}
